import React from 'react';
import './AppAlert.css';

const VARIANT_ALIASES = {
  danger: 'error',
};

const VARIANT_ICONS = {
  error: 'fa-circle-exclamation',
  success: 'fa-circle-check',
  warning: 'fa-triangle-exclamation',
  info: 'fa-circle-info',
};

const AppAlert = ({
  variant = 'info',
  title,
  message,
  children,
  onClose,
  dismissible = false,
  icon,
  className = '',
  style,
  role = 'alert',
}) => {
  const normalizedVariant = VARIANT_ALIASES[variant] || variant;
  const content = children ?? message;

  if (!content) return null;

  const shouldShowClose = dismissible || typeof onClose === 'function';
  const iconNode = icon || <i className={`fa-solid ${VARIANT_ICONS[normalizedVariant] || VARIANT_ICONS.info}`}></i>;

  return (
    <div
      className={`app-alert app-alert--${normalizedVariant} ${shouldShowClose ? 'app-alert--dismissible' : ''} ${className}`.trim()}
      style={style}
      role={role}
    >
      <div className="app-alert__icon" aria-hidden="true">
        {iconNode}
      </div>

      <div className="app-alert__content">
        {title && <div className="app-alert__title">{title}</div>}
        <div className="app-alert__message">{content}</div>
      </div>

      {shouldShowClose && (
        <button
          type="button"
          className="app-alert__close"
          onClick={onClose}
          aria-label="Fechar alerta"
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
      )}
    </div>
  );
};

export default AppAlert;
